// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--5-1!../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../node_modules/px2rem-loader/index.js??ref--5-3!./common.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("b34d145e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/common.css
// module id = ZsCP
// module chunks = 208